const styles = (theme) => ({
  tab: {
    fontFamily: theme.typography.fontKanit,
    opacity: 1,
    fontWeight: 500,
    '&:nth-of-type(even)': {
      borderRight: '0px solid #ccc',
      borderLeft: '0px solid #ccc',
    },
    '&:nth-last-of-type(1)': {
      borderRight: '1px solid #ccc',
    },
    border: '1px solid #ccc',
    borderBottom: 'none',
  },
  active_tab: {
    color: 'white',
    fontFamily: theme.typography.fontKanit,
    backgroundColor: theme.palette.primary.main,
    opacity: 1,
    fontWeight: 500,
  },
  container: {
    maxHeight: 506,
  },
  icon: {
    padding: theme.spacing(0),
  },
  status: {
    borderRadius: 4,
  },
  imgRadarSat: {
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      top: 0,
    },
  },
  imgRadar: {
    width: '100%',
    height: '100%',
  },
  title: {
    fontSize: 12,
    fontWeight: 600,
  },
  time: {
    fontSize: 10,
  },
  // color
  color0: {
    background: '#AED3FF',
    constrastColor: '#000',
  },
  color10: {
    background: '#AEECB7',
    constrastColor: '#000',
  },
  color20: {
    background: '#80C63D',
    constrastColor: '#000',
  },
  color35: {
    background: '#F0D447',
    constrastColor: '#000',
  },
  color50: {
    background: '#F08F36',
    constrastColor: '#000',
  },
  color70: {
    color: '#fff',
    background: '#BE6B27',
    constrastColor: '#fff',
  },
  color90: {
    color: '#fff',
    background: '#DB352E',
    constrastColor: '#fff',
  },
});

export default styles;
